var map = {
	"./apple-touch-icon.png": 4948,
	"./bushes.webp": 2368,
	"./favicon-32x32.png": 6656,
	"./favicon.svg": 1544,
	"./footer.webp": 2758,
	"./header.webp": 1980,
	"./opengraph.png": 2411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5085;